export default {
  component: () => import("../../../template/Login"),
  children: [
    {
      path: "",
      name: "login",
      component: () => import("../components/Auth"),
    },
  ],
}
